import React from 'react'

function FacebookFeed() {
    return (
<div class="fb-page" data-href="https://www.facebook.com/Zebra-aut&#xf3;siskola-102771398605350" data-tabs="timeline" data-width="350" data-height="" data-small-header="false" data-adapt-container-width="false" data-hide-cover="false" data-show-facepile="true"><blockquote cite="https://www.facebook.com/Zebra-aut&#xf3;siskola-102771398605350" class="fb-xfbml-parse-ignore"><a href="https://www.facebook.com/Zebra-aut&#xf3;siskola-102771398605350">Zebra autósiskola</a></blockquote></div>    )
}

export default FacebookFeed;
